const format = {
  full: 'HH:mm:ss',
  short: 'HH:mm',
};

export default { format };
